import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 're0008',
    ecrans: ['00-2'],
    params: ['id',
              '?indfor']
});
